import { useId } from 'react';

import type { IconProps } from './IconProps';

export const VerificationIcon = (props: IconProps) => {
  const iconId = useId().replace(/:/g, '');
  const clipPathId = `verification-icon-clip-${iconId}`;

  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-[#1C92FF]"
      width={props.width ?? 16}
      height={props.height ?? 16}
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M15.4082 7.875C15.4082 6.82031 14.8516 5.88281 14.0312 5.35547C14.2363 4.38867 13.9727 3.33398 13.2109 2.57227C12.4785 1.83984 11.4238 1.54688 10.457 1.75195C9.90039 0.931641 8.99219 0.375 7.9082 0.375C6.85352 0.375 5.91602 0.931641 5.35938 1.75195C4.42188 1.54688 3.36719 1.83984 2.60547 2.57227C1.87305 3.33398 1.58008 4.38867 1.78516 5.35547C0.964844 5.88281 0.408203 6.82031 0.408203 7.875C0.408203 8.95898 0.964844 9.89648 1.78516 10.4238C1.58008 11.3906 1.87305 12.4453 2.60547 13.1777C3.36719 13.9395 4.39258 14.2324 5.35938 14.0273C5.91602 14.8477 6.85352 15.375 7.9082 15.375C8.99219 15.375 9.90039 14.8477 10.457 14.0273C11.4238 14.2324 12.4785 13.9395 13.2109 13.1777C13.9727 12.4453 14.2363 11.3906 14.0312 10.4238C14.8809 9.89648 15.4082 8.95898 15.4082 7.875ZM10.75 6.73242L7.46875 10.0137C7.35156 10.1602 7.17578 10.2188 7 10.2188C6.79492 10.2188 6.61914 10.1602 6.50195 10.0137L5.0957 8.60742C4.80273 8.34375 4.80273 7.9043 5.0957 7.64062C5.35938 7.34766 5.79883 7.34766 6.0625 7.64062L7 8.54883L9.7832 5.76562C10.0469 5.47266 10.4863 5.47266 10.75 5.76562C11.043 6.0293 11.043 6.46875 10.75 6.73242Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
